/** 组件挂载只执行一次 */

import { useEffect, useRef } from 'react';

type CallBack = () => boolean;
const useOnce = (cb: CallBack, dependencies: any[]) => {
  const doneRef = useRef<boolean>(false);
  const cbRef = useRef<CallBack>();
  cbRef.current = cb;

  useEffect(() => {
    if (doneRef.current) return;
    doneRef.current = cbRef.current!();
  }, dependencies);
};

/** 组件挂载只执行一次, 可以异步控制是否算执行完一次 */
type CallbackAsync = (toggle: (executing: boolean) => void) => void;
export const useOnceAsync = (cb: CallbackAsync, dependencies: any[]) => {
  const executing = useRef(false);

  useEffect(() => {
    if (executing.current) return;
    executing.current = true;
    cb((e) => (executing.current = e));
  }, dependencies);
};

export default useOnce;
